import { useCallback, useState } from 'react'

export const useDisclosure = (initial = false) => {
  const [isOpen, setIsOpen] = useState(initial)

  const handleOpen = useCallback(() => setIsOpen(true), [])
  const handleClose = useCallback(() => setIsOpen(false), [])
  const handleToggle = useCallback(() => setIsOpen((state) => !state), [])

  return { isOpen, handleOpen, handleClose, handleToggle }
}

type UseDisclosureTuple = [boolean, () => void, () => void, () => void]

export const useDisclosureTuple = (initial = false): UseDisclosureTuple => {
  const { isOpen, handleOpen, handleClose, handleToggle } =
    useDisclosure(initial)
  return [isOpen, handleOpen, handleClose, handleToggle]
}

type UseDisclosureToggleTuple = [boolean, () => void]

export const useDisclosureToggleTuple = (
  initial = false
): UseDisclosureToggleTuple => {
  const { isOpen, handleToggle } = useDisclosure(initial)
  return [isOpen, handleToggle]
}
